<dx-data-grid
*ngIf="entity && productBatchExpenses"
[glamResource]="productBatchExpenses"
[customParams]="{ productBatchId:entity.id,productId:entity.productId}"
[createComponent]="batchExpenseAdd"
>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  
  <dxi-column dataField="date" [caption]="'common.date' | translate | ucfirst" dataType="date"/>
  <dxi-column dataField="description" [caption]="'entity.asset.description' | translate | ucfirst"/>
  <dxi-column dataField="cost" [caption]="'entity.containerType.cost' | translate | ucfirst" [format]="formatCurrencyTextBox"/>
  <dxi-column editCellTemplate="editOrganization" [caption]="'entity.organization.organization' | translate | ucfirst" dataField="organizationName" dataType="string">
    <div *dxTemplate="let data of 'editOrganization'">
      <dx-lookup
        [(value)]="data.data.organizationId" 
        (onValueChanged)="updateOrganization(data, $event)"
        [gsResource]="organizationResource"
        displayExpr="legalName" 
        valueExpr="id">
      </dx-lookup>
    </div>
  </dxi-column>

</dx-data-grid>